import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'sonner'
import { AppProviders } from '@/app/providers'
import App from './App'
import 'antd/dist/reset.css'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <App />
      <Toaster position="top-right" richColors />
    </AppProviders>
  </React.StrictMode>
)
